import { render, staticRenderFns } from "./SectionNine.vue?vue&type=template&id=a35fc2b8"
import script from "./SectionNine.vue?vue&type=script&lang=js"
export * from "./SectionNine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports